module.exports = __webpack_public_path__ + "static/coloured-logo-45d9074cb4482df244f73e5d54825b9b.svg";